import { Types } from '@store/types';

const initialState = {
	isCommonSurveyPopupOpen: false,
	isTrendSurveyPopupOpen: false,
	isHighlightFeedback: false
};

const surveySparrowReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.SET_IS_COMMON_SURVEY_POPUP_OPEN:
			return { ...state, isCommonSurveyPopupOpen: action.payload };
		case Types.SET_IS_TREND_SURVEY_POPUP_OPEN:
			return { ...state, isTrendSurveyPopupOpen: action.payload };
		case Types.SET_IS_HIGHLIGHT_FEEDBACK:
			return { ...state, isHighlightFeedback: action.payload };
		default:
			return state;
	}
};

export default surveySparrowReducer;
